import React, { useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";

import "./app-layout.scss";

const menuGroups = [
  {
    title: "Dashboard",
    items: [{ label: "Dashboard", icon: "ti-layout-dashboard", path: "/admin", end: true }],
  },
  {
    title: "Operations",
    items: [
      { label: "Orders", icon: "ti-receipt", path: "/admin/orders" },
    ],
  },
  {
    title: "Vendor",
    items: [{ label: "Vendors", icon: "ti-building-store", path: "/admin/vendors" }],
  },
  {
    title: "Administration",
    items: [
      { label: "Administrators", icon: "ti-users", path: "/admin/administrators" },
      { label: "Settings", icon: "ti-settings", path: "/admin/settings" },
    ],
  },
  {
    title: "Reports",
    items: [{ label: "Reports", icon: "ti-chart-bar", path: "/admin/reports" }],
  },
];

const pageTitles = {
  "/admin": "Dashboard",
  "/admin/orders": "Orders",
  "/admin/vendors": "Vendors",
  "/admin/administrators": "Administrators",
  "/admin/settings": "Settings",
  "/admin/reports": "Reports",
  "/admin/profile": "Edit Profile",
};

const resolvePageTitle = (pathname) => {
  if (pathname.startsWith("/admin/orders/")) {
    return "Order Detail";
  }

  return pageTitles[pathname] || "Admin Portal";
};

const AppLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <div className="app-layout">
      <aside className={`app-layout__sidebar ${sidebarOpen ? "app-layout__sidebar--open" : ""}`}>
        <div className="app-layout__brand">
          <div className="app-layout__brand-mark">SB</div>
          <div>
            <div className="app-layout__brand-name">SecondBite</div>
            <div className="app-layout__brand-subtitle">Admin Portal</div>
          </div>
        </div>

        <nav className="app-layout__menu">
          {menuGroups.map((group) => (
            <div className="app-layout__menu-group" key={group.title}>
              <div className="app-layout__menu-title">{group.title}</div>
              {group.items.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.end}
                  className={({ isActive }) =>
                    `app-layout__menu-item ${isActive ? "app-layout__menu-item--active" : ""}`
                  }
                  onClick={() => setSidebarOpen(false)}
                >
                  <span className="app-layout__menu-icon"><i className={`ti ${item.icon}`} aria-hidden="true"></i></span>
                  <span>{item.label}</span>
                </NavLink>
              ))}
            </div>
          ))}
        </nav>

        <div className="app-layout__mobile-logout">
          <button className="app-layout__logout" type="button" onClick={handleLogout}>
            <span className="app-layout__logout-icon"><i className="ti ti-logout" aria-hidden="true"></i></span>
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {sidebarOpen && (
        <button
          className="app-layout__overlay"
          type="button"
          aria-label="Close menu"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <main className="app-layout__main">
        <header className="app-layout__topbar">
          <button
            className="app-layout__menu-toggle"
            type="button"
            aria-label="Open menu"
            onClick={() => setSidebarOpen(true)}
          >
            <i className="ti ti-menu-2" aria-hidden="true"></i>
          </button>

          <div>
            <p className="app-layout__eyebrow">MVP B2B Platform</p>
            <h1 className="app-layout__title">{resolvePageTitle(location.pathname)}</h1>
          </div>

          <div className="app-layout__profile-wrap">
            <button
              className={`app-layout__profile ${profileOpen ? "app-layout__profile--open" : ""}`}
              type="button"
              aria-haspopup="menu"
              aria-expanded={profileOpen}
              onClick={() => setProfileOpen((open) => !open)}
            >
              <span className="app-layout__avatar">A</span>
              <span>Admin</span>
              <span className="app-layout__profile-chevron"><i className="ti ti-chevron-down" aria-hidden="true"></i></span>
            </button>

            {profileOpen && (
              <>
                <button
                  className="app-layout__profile-backdrop"
                  type="button"
                  aria-label="Close profile menu"
                  onClick={() => setProfileOpen(false)}
                />
                <div className="app-layout__profile-menu" role="menu">
                  <button
                    className="app-layout__profile-menu-item"
                    type="button"
                    role="menuitem"
                    onClick={() => {
                      setProfileOpen(false);
                      navigate("/admin/profile");
                    }}
                  >
                    <span className="app-layout__profile-menu-icon"><i className="ti ti-user-circle" aria-hidden="true"></i></span>
                    <span>Edit Profile</span>
                  </button>

                  <button
                    className="app-layout__profile-menu-item app-layout__profile-menu-item--danger"
                    type="button"
                    role="menuitem"
                    onClick={handleLogout}
                  >
                    <span className="app-layout__profile-menu-icon"><i className="ti ti-logout" aria-hidden="true"></i></span>
                    <span>Logout</span>
                  </button>
                </div>
              </>
            )}
          </div>
        </header>

        <section className="app-layout__content">
          <Outlet />
        </section>
      </main>
    </div>
  );
};

export default AppLayout;